import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SupportImgViewPageRoutingModule } from './support-img-view-routing.module';

import { SupportImgViewPage } from './support-img-view.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    IonicModule,
    SupportImgViewPageRoutingModule
  ],
  declarations: [SupportImgViewPage]
})
export class SupportImgViewPageModule {}
